import React from "react";
import { Link } from "react-router-dom";
import { Tooltip, Typography } from "antd";
import IntlMessage from "../util-components/IntlMessage";

const { Text } = Typography;
const env = process.env.REACT_APP_ENVIRONMENT.toLowerCase() || "development";

export default function Footer(props) {
  const apiVersion = () => {
    if (props.apiVersion !== undefined) {
      return (
        <div className="api-text" style={{ marginLeft: 5, color: "#bbbbbb" }}>
          <small> (Versão API: {props.apiVersion})</small>
        </div>
      );
    }
    return <></>;
  };
  const apiVersionText = `API: ${props.apiVersion}`;
  return (
    <footer className="footer" style={{ margin: "0px 70px 0px 20px" }}>
      <div style={{ display: "flex", justifyContent: "left" }}>
        <span>
          Copyright &copy; {`${new Date().getFullYear()}`} <span className="font-weight-semibold">SalesPark</span> - Feito com{" "}
          <Tooltip placement="right" title="Feito com amor e muito café">
            ❤️ e ☕
          </Tooltip>{" "}
          - versão 2.5.1490
        </span>
        {apiVersion()}
        {env !== "production" && (
          <small>
            <Text className="ml-2" type="secondary" style={{ marginLeft: 5 }} copyable>
              App: 2.5.1490
            </Text>
            <Text className="ml-2" type="secondary" style={{ marginLeft: 5 }} copyable>
              {apiVersionText}
            </Text>
          </small>
        )}
      </div>
      <div>
        <Link className="text-gray" to={{ pathname: "https://ajuda.salespark.io/help/termos-gerais-de-uso-da-salespark" }} target="_blank">
          <IntlMessage id="footer.general_terms_of_use" />
        </Link>
        {/* <span className="mx-2 text-muted"> | </span> */}
      </div>
    </footer>
  );
}
